import React, { Component } from 'react'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import http from '../../services/httpService'
import { Link } from 'react-router-dom'

class UserListingStatusesTable extends Component {
  state = { data: [], pages: null, loading: true }
  columns = [
    {
      id: 'edit', Header: '#', accessor: d => 'View', filterable: false, sortable: false, width: 50,
      Cell: props => (
        <Link to={`/parsedhouses/${this.state.data[props.index].parsedHouseId}`}>
          {props.value}
        </Link>
      )
    },
    {
      id: 'address', Header: 'Address', accessor: d => d.address, filterable: true, width: 250,
      Cell: props => (
        <a target="_blank" rel="noreferrer" href={this.state.data[props.index].url}>
          {props.value}
        </a>
      )
    },
    { id: 'city', Header: 'City', accessor: d => d.city, filterable: true, width: 120 },
    { id: 'price', Header: 'Price', accessor: d => d.price, filterable: false, width: 80 },
    {
      id: 'status', Header: 'Status', accessor: d => d.status, filterable: true, width: 120,
      Filter: ({ filter, onChange }) => (
        <select
          onChange={event => onChange(event.target.value)}
          style={{ width: "100%" }}
          value={filter ? filter.value : ""}
        >
          <option value="">All</option>
          <option value="Viewed">Viewed</option>
          <option value="Applied">Applied</option>
          <option value="Archived">Archived</option>
          <option value="Interested">Interested</option>
          <option value="Not Interested">Not Interested</option>
        </select>
      )
    },
    { id: 'modifiedDate', Header: 'Last Updated', accessor: d => d.modifiedDate, filterable: false, width: 180 }
  ]

  fetchData = async (state, instance) => {
    this.setState({ loading: true })

    const { pageSize, page, sorted, filtered } = state
    const url = `userlistingstatuses/user/${this.props.userId}`
    const { data } = await http.post(url, { pageSize, page, sorted, filtered })

    this.setState({
      data: data.rows,
      pages: data.pages,
      loading: false
    })
  }

  render () {
    const { data, loading, pages } = this.state
    const columns = this.columns
    return (
      <div className="my-4">
        <h5>Listing Statuses</h5>
        <ReactTable manual data={data} pages={pages} loading={loading} columns={columns}
                    filterable onFetchData={this.fetchData}
        />
      </div>
    )
  }
}

export default UserListingStatusesTable
